import { show } from 'store/rebuildUserAccessSlice';
import { MainMenuItemsList } from 'app/navbar/MenuConfig';

export const adminMenuItems: MainMenuItemsList = [
    {
        label: 'admin.access_request',
        key: 'admin_access_request',
        href: '/editor/user/access-request',
        icon: { type: 'mi', value: 'lock' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_MANAGE_ACCESS_REQUESTS' }],
    },
    {
        label: 'admin.user',
        key: 'admin_user',
        href: '/editor/user',
        icon: { type: 'mi', value: 'user-groups' },
    },
    {
        divider: true,
    },
    {
        label: 'admin.data_source',
        key: 'admin_data_source_main',
        icon: { type: 'mi', value: 'data-source' },
        children: [
            {
                label: 'admin.data_sources',
                key: 'admin_data_source',
                href: '/editor/data-source',
                icon: { type: 'mi', value: 'data-source' },
                searchData: {
                    desc: 'data_source',
                    keywords: {
                        entity: ['data_source'],
                    },
                    groupKey: 'collection_and_storage',
                },
            },
            {
                label: 'admin.triggers',
                key: 'admin_triggers',
                href: '/editor/trigger',
                icon: { type: 'mi', value: 'trigger' },
                searchData: {
                    desc: 'trigger',
                    keywords: {
                        entity: ['trigger'],
                    },
                    groupKey: 'collection_and_storage',
                },
            },
            {
                label: 'admin.dependency',
                key: 'admin_dependency',
                href: '/editor/dependency',
                icon: { type: 'mi', value: 'data-dependencies' },
                searchData: {
                    desc: 'dependency',
                    keywords: {
                        entity: ['dependency'],
                    },
                    groupKey: 'collection_and_storage',
                },
            },
            {
                label: 'admin.remote_data_processor',
                key: 'admin_remote_data_processor',
                href: '/editor/remote-agent',
                icon: { type: 'mi', value: 'rdps' },
                searchData: {
                    desc: 'remote_data_processor',
                    keywords: {
                        entity: ['remote_data_processor'],
                    },
                    groupKey: 'collection_and_storage',
                },
            },
            {
                label: 'admin.storage',
                key: 'admin_storage',
                href: '/admin/storage',
                icon: { type: 'mi', value: 'data-storage' },
                searchData: {
                    keywords: {
                        entity: ['storage'],
                    },
                    groupKey: 'collection_and_storage',
                },
            },
            {
                label: 'admin.proxies',
                key: 'admin_proxies',
                href: '/editor/proxy',
                icon: { type: 'mi', value: 'proxies' },
                searchData: {
                    keywords: {
                        entity: ['proxy'],
                    },
                    groupKey: 'collection_and_storage',
                },
            },
        ],
    },
    {
        label: 'admin.concierge',
        key: 'admin_concierge_main',
        icon: { type: 'mi', value: 'concierge' },
        children: [
            {
                label: 'admin.knowledge_graph_editor',
                key: 'admin_knowledge_graph_editor',
                href: '/editor/graph/node',
                icon: { type: 'mi', value: 'knowledge-graph-editor' },
                searchData: {
                    labelSuffix: 'none',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'concierge',
                },
            },
            {
                label: 'admin.measure_conflicts',
                key: 'admin_measure_conflicts',
                href: '/editor/measure-conflicts',
                icon: { type: 'mi', value: 'measure-inconsistencies' },
                condition: [
                    { type: 'conciergeEnabled' },
                    { type: 'adminOrPrivilege', params: 'PRIV_MANAGE_KNOWLEDGE_GRAPH' },
                ],
                searchData: {
                    keywords: {
                        entity: ['measure_conflict'],
                    },
                },
            },
            {
                label: 'admin.benchmarks',
                key: 'admin_benchmarks',
                href: '/editor/benchmark',
                icon: { type: 'mi', value: 'benchmark' },
                searchData: {
                    labelSuffix: 'none',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'concierge',
                },
            },
            {
                label: 'admin.learnings',
                key: 'admin_learnings',
                href: '/editor/llm/learning',
                icon: { type: 'mi', value: 'lightbulb' },
                condition: [
                    {
                        type: 'atLeastOneCondition',
                        params: [
                            { type: 'adminOrPrivilege', params: 'PRIV_MANAGE_GLOBAL_LEARNINGS' },
                            { type: 'adminOrPrivilege', params: 'PRIV_MANAGE_KNOWLEDGE_GRAPH' },
                        ],
                    },
                ],
                searchData: {
                    labelSuffix: 'none',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'concierge',
                },
            },
            {
                divider: true,
            },

            {
                label: 'admin.concierge_setup',
                key: 'admin_concierge_setup',
                href: '/admin/concierge',
                icon: { type: 'mi', value: 'concierge-setup' },
                searchData: {
                    labelSuffix: 'editor',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'concierge',
                },
            },
            {
                label: 'admin.domain',
                key: 'admin_domain',
                href: '/admin/domain',
                icon: { type: 'mi', value: 'domains' },
                condition: [{ type: 'conciergeEnabled' }],
                searchData: {
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'concierge',
                },
            },
            {
                label: 'admin.knowledge_graph_monitor',
                key: 'admin_knowledge_graph_monitor',
                href: '/editor/graph/monitor',
                icon: { type: 'mi', value: 'knowledge-graph-monitor' },
                searchData: {
                    labelSuffix: 'none',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'concierge',
                },
            },
            {
                label: 'admin.concierge_usage',
                key: 'admin_concierge_usage',
                href: '/admin/concierge/usage',
                icon: { type: 'mi', value: 'badge-dollar' },
                condition: [{ type: 'adminOrPrivilege', params: 'PRIV_VIEW_CONCIERGE_USAGE' }],
                searchData: {
                    labelSuffix: 'editor',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'concierge',
                },
            },
        ],
    },
    {
        label: 'admin.distribution',
        key: 'admin_distribution',
        icon: { type: 'mi', value: 'distribution' },
        children: [
            {
                label: 'admin.ns',
                key: 'admin_ns',
                href: '/editor/schedule',
                icon: { type: 'mi', value: 'notification-schedule' },
                searchData: {
                    desc: 'ns',
                    keywords: {
                        entity: ['ns'],
                    },
                    groupKey: 'distribution',
                },
            },
            {
                label: 'admin.email_template',
                key: 'admin_email_template',
                href: '/editor/email-template',
                icon: { type: 'mi', value: 'email-template' },
                searchData: {
                    desc: 'email_template',
                    keywords: {
                        entity: ['email_template'],
                        entityAlias: ['digest_template'],
                    },
                    groupKey: 'distribution',
                },
            },
            {
                label: 'admin.ftp',
                key: 'admin_ftp',
                href: '/editor/ftp',
                icon: { type: 'mi', value: 'ftp-connection' },
                searchData: {
                    keywords: {
                        entity: ['ftp'],
                    },
                    groupKey: 'distribution',
                },
            },
            {
                label: 'admin.shared_drive',
                key: 'admin_shared_drive',
                href: '/editor/shared-drive',
                icon: { type: 'mi', value: 'shared-drive' },
                searchData: {
                    keywords: {
                        entity: ['shared_drive'],
                    },
                    groupKey: 'distribution',
                },
            },
            {
                label: 'admin.slack_integration',
                key: 'admin_slack_integration',
                href: '/editor/slack',
                icon: { type: 'mi', value: 'slack' },
                searchData: {
                    labelSuffix: 'editor',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'distribution',
                },
            },
            {
                label: 'admin.slack_channel',
                key: 'admin_slack_channel',
                href: '/editor/slack/channel',
                icon: { type: 'mi', value: 'slack' },
                searchData: {
                    labelSuffix: 'editor',
                    keywords: {
                        entity: ['slack_channel'],
                    },
                    groupKey: 'distribution',
                },
            },
            {
                label: 'admin.sharepoint',
                key: 'admin_sharepoint',
                href: '/editor/ms-sharepoint',
                icon: { type: 'mi', value: 'microsoft-sharepoint' },
                searchData: {
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'distribution',
                },
            },
            {
                label: 'admin.ms_teams',
                key: 'admin_ms_teams',
                href: '/editor/ms-teams',
                icon: { type: 'mi', value: 'microsoft-teams' },
                searchData: {
                    labelSuffix: 'editor',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'distribution',
                },
            },
        ],
    },
    {
        divider: true,
    },
    {
        label: 'admin.reference_object',
        key: 'admin_reference_object',
        icon: { type: 'mi', value: 'reference-object' },
        children: [
            {
                label: 'admin.custom_field',
                key: 'admin_custom_field',
                href: '/editor/custom-field',
                icon: { type: 'mi', value: 'custom-field' },
                searchData: {
                    desc: 'custom_field',
                    keywords: {
                        entity: ['custom_field'],
                    },
                    groupKey: 'reference_object',
                },
            },
            {
                label: 'admin.template',
                key: 'admin_template',
                href: '/editor/template',
                icon: { type: 'mi', value: 'template' },
                searchData: {
                    desc: 'object_template',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'reference_object',
                },
            },
            {
                label: 'admin.event_calendar',
                key: 'admin_event_calendar',
                href: '/editor/event-calendar',
                icon: { type: 'mi', value: 'event-calendar' },
                searchData: {
                    desc: 'event_calendar',
                    keywords: {
                        entity: ['event_calendar'],
                    },
                    groupKey: 'reference_object',
                },
            },
            {
                label: 'admin.target',
                key: 'admin_target',
                href: '/editor/target',
                icon: { type: 'mi', value: 'target' },
                searchData: {
                    desc: 'target',
                    keywords: {
                        entity: ['target'],
                    },
                    groupKey: 'reference_object',
                },
            },
            {
                label: 'admin.mask',
                key: 'admin_mask',
                href: '/editor/mask',
                icon: { type: 'mi', value: 'mask' },
                searchData: {
                    keywords: {
                        entity: ['display_mask'],
                    },
                    groupKey: 'reference_object',
                },
            },
            {
                label: 'admin.measurement_interval',
                key: 'admin_measurement_interval',
                href: '/editor/measurement-interval',
                icon: { type: 'mi', value: 'measurement-interval' },
                searchData: {
                    desc: 'measurement_interval',
                    keywords: {
                        entity: ['measurement_interval'],
                    },
                    groupKey: 'reference_object',
                },
            },
            {
                label: 'admin.command',
                key: 'admin_command',
                href: '/editor/command',
                icon: { type: 'mi', value: 'meas-time-calcs' },
                searchData: {
                    desc: 'measurement_time_calc_command',
                    keywords: {
                        entity: ['measurement_time_calc_command'],
                        manuLabel: true,
                    },
                    groupKey: 'reference_object',
                },
            },
            {
                label: 'admin.document_types',
                key: 'admin_document_types',
                href: '/editor/document-type',
                icon: { type: 'mi', value: 'document-type' },
                searchData: {
                    keywords: {
                        entity: ['document_type'],
                    },
                    groupKey: 'reference_object',
                },
            },
            {
                label: 'admin.business_unit',
                key: 'admin_business_unit',
                href: '/editor/business-unit',
                icon: { type: 'mi', value: 'business-unit' },
            },
        ],
    },
    {
        divider: true,
    },
    {
        label: 'admin.status_monitor',
        key: 'admin_status_monitor',
        href: '/monitor',
        icon: { type: 'mi', value: 'status-monitor' },
        searchData: {
            labelSuffix: 'page',
            keywords: {
                manuLabel: true,
            },
        },
    },
    {
        label: 'admin.plugin',
        key: 'admin_plugin',
        icon: { type: 'mi', value: 'plugin' },
        children: [
            {
                label: 'admin.plugin_url_template',
                key: 'admin_plugin_url_template',
                href: '/editor/plugin-url-template',
                icon: { type: 'mi', value: 'plugin-urls' },
                searchData: {
                    desc: 'plugin_url_template',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'plugin',
                },
            },
            {
                label: 'admin.report_type',
                key: 'admin_report_type',
                href: '/editor/ext-report-type',
                icon: { type: 'mi', value: 'external-report' },
                searchData: {
                    desc: 'external_report_type',
                    keywords: {
                        entity: ['external_report_type'],
                    },
                    groupKey: 'plugin',
                },
            },
            {
                label: 'admin.external_content_type',
                key: 'admin_external_content_type',
                href: '/editor/ext-content-type',
                icon: { type: 'mi', value: 'external-content' },
            },
            {
                label: 'admin.content_type',
                key: 'admin_content_type',
                href: '/editor/content-type',
                icon: { type: 'mi', value: 'external-content' },
                searchData: {
                    desc: 'external_content_type',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'plugin',
                },
            },
            {
                label: 'admin.advanced_configuration',
                key: 'admin_advanced_configuration',
                href: '/admin/plugin-config',
                icon: { type: 'mi', value: 'advanced-configuration' },
                searchData: {
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'plugin',
                },
            },
        ],
    },
    {
        label: 'admin.utilities',
        key: 'admin_utilities',
        icon: { type: 'mi', value: 'utilities' },
        children: [
            {
                label: 'admin.import_export',
                key: 'admin_import_export',
                href: '/admin/content',
                icon: { type: 'mi', value: 'import-export' },
                searchData: {
                    desc: 'import_export',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'utilities',
                },
            },
            {
                label: 'admin.export_locations',
                key: 'admin_export_locations',
                href: '/admin/content/export/location',
                icon: { type: 'mi', value: 'export-locations' },
                searchData: {
                    keywords: {
                        entity: ['export_location'],
                    },
                    groupKey: 'utilities',
                },
            },
            {
                label: 'admin.import_export_history',
                key: 'admin_import_export_history',
                href: '/admin/import-export-history',
                icon: { type: 'mi', value: 'import-export-history' },
                searchData: {
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'utilities',
                },
            },
            {
                label: 'admin.metadata_propagation',
                key: 'admin_metadata_propagation',
                href: '/editor/metadata-prop',
                icon: { type: 'mi', value: 'metadata-propagation' },
                searchData: {
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'utilities',
                },
            },
            {
                label: 'admin.rebuild_user_access',
                key: 'editor_rebuild_user_access',
                icon: { type: 'mi', value: 'rebuild-user-access' },
                action: ({ dispatch }) => {
                    if (dispatch) {
                        dispatch(show());
                    }
                },
                searchData: {
                    labelSuffix: 'none',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'utilities',
                },
            },
        ],
    },
    {
        label: 'admin.system',
        key: 'admin_system',
        icon: { type: 'mi', value: 'system' },
        children: [
            {
                label: 'admin.system_variables',
                key: 'admin_system_variables',
                href: '/admin/system-variables',
                icon: { type: 'mi', value: 'system' },
                condition: [{ type: 'isSystemAdmin' }],
                searchData: {
                    keywords: {
                        entity: ['system_variable'],
                    },
                    groupKey: 'system',
                },
            },
            {
                divider: true,
                condition: [{ type: 'isSystemAdmin' }],
            },
            {
                label: 'admin.brand',
                key: 'admin_brand',
                href: '/editor/brand',
                icon: { type: 'mi', value: 'branding' },
                searchData: {
                    desc: 'brand',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.brand_theme',
                key: 'admin_brand_theme',
                href: '/editor/brand-theme',
                icon: { type: 'mi', value: 'color-picker' },
                searchData: {
                    keywords: {
                        entity: ['brand_theme'],
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.vocabulary',
                key: 'admin_vocabulary',
                href: '/admin/vocabulary',
                icon: { type: 'mi', value: 'vocabulary' },
                searchData: {
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.custom_script',
                key: 'admin_custom_script',
                href: '/admin/custom-script',
                icon: { type: 'mi', value: 'custom-scripts' },
                searchData: {
                    desc: 'custom_script',
                    keywords: {
                        entity: ['custom_script'],
                    },
                    groupKey: 'system',
                },
            },
            {
                divider: true,
            },
            {
                label: 'admin.privilege_set',
                key: 'admin_privilege_set',
                href: '/editor/privilege-set',
                icon: { type: 'mi', value: 'privilege-sets' },
            },
            {
                divider: true,
            },
            {
                label: 'admin.ppt',
                key: 'admin_ppt',
                href: '/editor/ppt/',
                icon: { type: 'mi', value: 'file-powerpoint' },
                searchData: {
                    desc: 'power_point_template',
                    keywords: {
                        entity: ['power_point_template'],
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.javascript_chart_template',
                key: 'admin_javascript_chart_template',
                href: '/editor/javascript-chart-template',
                icon: { type: 'mi', value: 'charting-options' },
                searchData: {
                    desc: 'javascript_chart_template',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'system',
                },
            },
            {
                divider: true,
            },
            {
                label: 'admin.api_toolkit',
                key: 'admin_api_toolkit',
                href: '/api',
                icon: { type: 'mi', value: 'api-toolkit' },
                searchData: {
                    desc: 'api_toolkit',
                    labelSuffix: 'editor',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.api_token',
                key: 'admin_api_token',
                href: '/api-token',
                icon: { type: 'mi', value: 'api-token' },
                searchData: {
                    keywords: {
                        entity: ['api_token'],
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.search',
                key: 'admin_search',
                href: '/admin/search',
                icon: { type: 'mi', value: 'search-setup' },
                searchData: {
                    labelSuffix: 'editor',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.certification_level',
                key: 'admin_certification_level',
                href: '/admin/certification-level',
                icon: { type: 'mi', value: 'certification-setup' },
                searchData: {
                    keywords: {
                        entity: ['certification_level'],
                        manuLabel: true,
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.glossary_setup',
                key: 'admin_glossary_setup',
                href: '/admin/glossary-setup',
                icon: { type: 'mi', value: 'glossary' },
                searchData: {
                    keywords: {
                        entity: ['glossary_term_status'],
                        manuLabel: true,
                    },
                    groupKey: 'system',
                },
            },
            {
                label: 'admin.owner_field_setup',
                key: 'owner_field_setup',
                href: '/admin/owner',
                icon: { type: 'mi', value: 'owner-field-setup' },
                searchData: {
                    labelSuffix: 'editor',
                    keywords: {
                        manuLabel: true,
                    },
                    groupKey: 'system',
                },
            },
            {
                divider: true,
            },
            {
                label: 'admin.privilege',
                key: 'admin_privilege',
                href: '/editor/privilege',
                icon: { type: 'mi', value: 'privilege-sets' },
                searchData: {
                    keywords: {
                        entity: ['privilege'],
                    },
                    groupKey: 'system',
                },
            },
            {
                divider: true,
            },
            {
                label: 'admin.identity_profile',
                key: 'admin_identity_profile',
                href: '/editor/identity-profile',
                icon: { type: 'mi', value: 'identity-profile' },
                searchData: {
                    keywords: {
                        entity: ['identity_profile'],
                    },
                    groupKey: 'system',
                },
            },
            {
                divider: true,
            },
            {
                label: 'admin.external_application',
                key: 'admin_external_application',
                href: '/editor/external-application',
                icon: { type: 'mi', value: 'external-applications' },
                searchData: {
                    desc: 'external_application',
                    keywords: {
                        entity: ['external_application'],
                    },
                    groupKey: 'system',
                },
            },
        ],
    },
];
export const adminMenuItemsPower: MainMenuItemsList = [
    {
        label: 'admin.group',
        key: 'admin_group',
        href: '/editor/group',
        icon: { type: 'mi', value: 'user-groups' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_MANAGE_GROUPS' }],
    },
    {
        label: 'admin.access_request',
        key: 'admin_access_request',
        href: '/editor/user/access-request',
        icon: { type: 'mi', value: 'lock' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_MANAGE_ACCESS_REQUESTS' }],
    },
    {
        label: 'admin.users',
        key: 'admin_user_login_as',
        href: '/editor/user/login-as',
        icon: { type: 'mi', value: 'spy' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_LOGIN_AS_MEMBER_OF_GROUP' }],
    },
    {
        divider: true,
        condition: [
            {
                type: 'atLeastOneCondition',
                params: [
                    { type: 'havePrivilege', params: 'PRIV_CREATE_MANAGE_GROUPS' },
                    { type: 'havePrivilege', params: 'PRIV_MANAGE_ACCESS_REQUESTS' },
                    { type: 'havePrivilege', params: 'PRIV_LOGIN_AS_MEMBER_OF_GROUP' },
                ],
            },
        ],
    },
    {
        label: 'admin.data_sources',
        key: 'admin_data_source',
        href: '/editor/data-source',
        icon: { type: 'mi', value: 'data-source' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_DATA_SOURCE' }],
        searchData: {
            desc: 'data_source',
            keywords: {
                entity: ['data_source'],
            },
            groupKey: 'collection_and_storage',
        },
    },
    {
        label: 'admin.triggers',
        key: 'admin_triggers',
        href: '/editor/trigger',
        icon: { type: 'mi', value: 'trigger' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_COLLECTION_TRIGGERS' }],
        searchData: {
            desc: 'trigger',
            keywords: {
                entity: ['trigger'],
            },
            groupKey: 'collection_and_storage',
        },
    },
    {
        label: 'admin.dependency',
        key: 'admin_dependency',
        href: '/editor/dependency',
        icon: { type: 'mi', value: 'data-dependencies' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_DATA_DEPENDENCIES' }],
        searchData: {
            desc: 'dependency',
            keywords: {
                entity: ['dependency'],
            },
            groupKey: 'collection_and_storage',
        },
    },
    {
        divider: true,
        condition: [
            {
                type: 'atLeastOneCondition',
                params: [
                    { type: 'havePrivilege', params: 'PRIV_CREATE_DATA_SOURCE' },
                    { type: 'havePrivilege', params: 'PRIV_CREATE_COLLECTION_TRIGGERS' },
                    { type: 'havePrivilege', params: 'PRIV_CREATE_DATA_DEPENDENCIES' },
                ],
            },
        ],
    },
    {
        label: 'admin.custom_field_section',
        key: 'admin_custom_field_section',
        href: '/editor/custom-field/section',
        icon: { type: 'mi', value: 'sections' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_CUSTOM_FIELD_SECTIONS' }],
        searchData: {
            keywords: {
                entity: ['custom_field_section_one'],
            },
        },
    },
    {
        label: 'admin.ns',
        key: 'admin_ns',
        href: '/editor/schedule',
        icon: { type: 'mi', value: 'notification-schedule' },
        // condition: [{ type: 'havePrivilege', params: 'PRIV_FULL_NS_EDITOR' }],
        searchData: {
            desc: 'ns',
            keywords: {
                entity: ['ns'],
            },
            groupKey: 'distribution',
        },
    },
    {
        label: 'admin.email_template',
        key: 'admin_email_template',
        href: '/editor/email-template',
        icon: { type: 'mi', value: 'email-template' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_DIGEST_TEMPLATE' }],
        searchData: {
            desc: 'email_template',
            keywords: {
                entity: ['email_template'],
                entityAlias: ['digest_template'],
            },
            groupKey: 'distribution',
        },
    },
    {
        label: 'admin.ftp',
        key: 'admin_ftp',
        href: '/editor/ftp',
        icon: { type: 'mi', value: 'ftp-connection' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_FTP_CONNECTION' }],
        searchData: {
            keywords: {
                entity: ['ftp'],
            },
            groupKey: 'distribution',
        },
    },
    {
        label: 'admin.slack_channel',
        key: 'admin_slack_channel',
        href: '/editor/slack/channel',
        icon: { type: 'mi', value: 'slack' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_DESIGNATE_SLACK_CHANNEL' }],
        searchData: {
            labelSuffix: 'editor',
            keywords: {
                entity: ['slack_channel'],
            },
            groupKey: 'distribution',
        },
    },
    {
        divider: true,
    },
    {
        label: 'admin.event_calendar',
        key: 'admin_event_calendar',
        href: '/editor/event-calendar',
        icon: { type: 'mi', value: 'event-calendar' },
        searchData: {
            desc: 'event_calendar',
            keywords: {
                entity: ['event_calendar'],
            },
            groupKey: 'reference_object',
        },
    },
    {
        label: 'admin.target',
        key: 'admin_target',
        href: '/editor/target',
        icon: { type: 'mi', value: 'target' },
        searchData: {
            desc: 'target',
            keywords: {
                entity: ['target'],
            },
            groupKey: 'reference_object',
        },
    },
    {
        label: 'admin.domain',
        key: 'admin_domain',
        href: '/admin/domain',
        icon: { type: 'mi', value: 'domains' },
        condition: [{ type: 'conciergeEnabled' }, { type: 'havePrivilege', params: 'PRIV_ADD_DOMAINS' }],
        searchData: {
            keywords: {
                manuLabel: true,
            },
            groupKey: 'system',
        },
    },
    {
        label: 'admin.javascript_chart_template',
        key: 'admin_javascript_chart_template',
        href: '/editor/javascript-chart-template',
        icon: { type: 'mi', value: 'charting-options' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_JS_CHART_TEMPLATE' }],
        searchData: {
            desc: 'javascript_chart_template',
            keywords: {
                manuLabel: true,
            },
            groupKey: 'system',
        },
    },
    {
        label: 'admin.report_type',
        key: 'admin_report_type',
        href: '/editor/ext-report-type',
        icon: { type: 'mi', value: 'external-report' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_EXTERNAL_REPORT_TYPE' }],
        searchData: {
            desc: 'external_report_type',
            keywords: {
                entity: ['external_report_type'],
            },
            groupKey: 'plugin',
        },
    },
    {
        label: 'admin.api_toolkit',
        key: 'admin_api_toolkit',
        href: '/api',
        icon: { type: 'mi', value: 'api-toolkit' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_USE_API_TOOLKIT' }],
        searchData: {
            desc: 'api_toolkit',
            labelSuffix: 'editor',
            keywords: {
                manuLabel: true,
            },
            groupKey: 'system',
        },
    },
    {
        label: 'admin.api_token',
        key: 'admin_api_token',
        href: '/api-token',
        icon: { type: 'mi', value: 'api-token' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_USE_API_TOKENS' }],
        searchData: {
            keywords: {
                entity: ['api_token'],
            },
            groupKey: 'system',
        },
    },
    {
        label: 'admin.business_unit',
        key: 'admin_business_unit',
        href: '/editor/business-unit',
        icon: { type: 'mi', value: 'business-unit' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_CREATE_BUSINESS_UNITS' }],
    },
    {
        label: 'admin.metadata_propagation',
        key: 'admin_metadata_propagation',
        href: '/editor/metadata-prop',
        icon: { type: 'mi', value: 'metadata-propagation' },
        condition: [{ type: 'havePrivilege', params: 'PRIV_MANAGE_METADATA_PROPAGATION_RULES' }],
        searchData: {
            keywords: {
                manuLabel: true,
            },
            groupKey: 'utilities',
        },
    },
];
